require('../style/style.scss');
//require("html/index.html")
//require("vendor/eve.js")
//require("vendor/chartist.min.css")
//require("vendor/jsencrypt.js")
//require("vendor/raphael.min.js")
//require("vendor/bootstrap-filestyle.min.js")

import React from 'react';
import * as ReactDOM from 'react-dom';
import { RootRouter } from './component';

window['debug'] = {};

ReactDOM.render(<RootRouter />, window.document.getElementById('app'));
